import gql from 'graphql-tag';

export default gql`
  mutation DietSetCopyMutation($sourceDate: Date!, $targetDate: Date!) {
    me {
      dietSetCopy(sourceDate: $sourceDate, targetDate: $targetDate) {
        __typename
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on BasicMutationSuccess {
          code
        }
      }
    }
  }
`;
